import { Card } from 'primereact/card';
import React from 'react';

export interface CardsWithIconModel {
  title: string;
  bodyText: React.ReactNode[];
  icon: any;
  iconBgColor: string;
}

export const CardsWithIcon: React.FC<CardsWithIconModel> = ({
  title,
  bodyText,
  icon,
  iconBgColor,
}) => {
  const isStringIcon = typeof icon === 'string';

  return (
    <Card
      title={title}
      style={{
        minWidth: '400px',
        maxWidth: '500px',
        flex: '1 1 auto',
        border: '0.5px solid #4b5563',
        boxShadow: 'none',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: '24px',
        }}
      >
        {/* Icon Section */}
        <div
          style={{
            width: '64px',
            minWidth: '64px',
            height: '64px',
            backgroundColor: iconBgColor,
            borderRadius: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {isStringIcon ? (
            <i
              className={icon}
              style={{ fontSize: '2rem', color: '#2196F3' }}
            />
          ) : (
            <img src={icon} style={{ width: '32px', height: '32px' }} />
          )}
        </div>

        {/* Text Content Section */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            flex: 1,
          }}
        >
          {bodyText.map((text, index) => (
            <div
              key={index}
              style={{
                fontSize: '16px',
                fontWeight: '500',
                color: '#1f2937',
                lineHeight: '1.5',
              }}
            >
              {text}
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
};
